import PropTypes from 'prop-types';
import React from 'react';
import { useStateValue } from '../../state';

const SearchIcon = ({ onClick }) => {
	const [{ _t }] = useStateValue();
	return (
		<button
			id="search-mobile-button"
			type="button"
			className="flex flex-col flex-wrap items-center block bg-transparent border-0 cursor-pointer w-full lg:hidden"
			onClick={onClick}>
			<i className="ico ico-search text-ongreen"></i>
			<span className="static text-body-xs text-primary font-regular">{_t.label}</span>
		</button>
	);
};

SearchIcon.propTypes = {
	onClick: PropTypes.func,
};

export default SearchIcon;
